import * as t from 'io-ts'
import { TransactionType } from '../TransactionType'
import { Maybe } from '@mxt/zio/codec'
import { CashoutOptions } from './CashoutOptions'
const Base = <C extends t.Mixed>(codec: C) => t.intersection([
  t.type({
    transactionType: t.literal(TransactionType.SURRENDER_VALUE_PAYMENT_FOR_AUTO_TERMINATED_POLICY)
  }),
  codec
])

export const SurrenderValuePaymentForAutoTerminatedPolicy = Base(t.type({
  payload: t.type({
    source: t.string,
    body: t.type({
      policy: t.type({
        policyNo: t.string
      }),
      attributesExt: t.type({
        AUTO_TERMINATED_POLICY_AMOUNT: t.number,
        TOTAL_PAYOUT_AMOUNT: t.number
      }),
      cashOutOptions: Maybe(CashoutOptions)
    })
  })
}))

export type SurrenderValuePaymentForAutoTerminatedPolicy = t.TypeOf<typeof SurrenderValuePaymentForAutoTerminatedPolicy>